import { render, staticRenderFns } from "./labelAdd.vue?vue&type=template&id=7488133d&scoped=true"
import script from "./labelAdd.vue?vue&type=script&lang=js"
export * from "./labelAdd.vue?vue&type=script&lang=js"
import style0 from "./labelAdd.vue?vue&type=style&index=0&id=7488133d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7488133d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7488133d')) {
      api.createRecord('7488133d', component.options)
    } else {
      api.reload('7488133d', component.options)
    }
    module.hot.accept("./labelAdd.vue?vue&type=template&id=7488133d&scoped=true", function () {
      api.rerender('7488133d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LabelGroup/labelAdd.vue"
export default component.exports